import {
  version,
  checkDeviceStatus,
  echo,
  getDutySection,
  userLogin,
  userLogout,
  openCashBox,
  notificationSummary,
  notificationList,
  notificationRead,
  applicationInfo,
  deviceList,
  deviceSave,
  reboot,
  shutdown, applicationConfig,
} from '@/api/system';
import { useConfirm } from '@/utils/confirm';
import Router from '../../router';
export default {
  namespaced: true,
  state: {
    config: null,
    session: null,
    system: null,
    count: null,
    marquee_text: '',
    slideshows: [],
    system_version: '',
    front_end_version: process.env.VUE_APP_VERSION,
    environment: process.env.VUE_APP_ENV,
    permission: null,
    isTestMode: false,
  },

  getters: {
    getConfig: (state) => state.config,
    getSession: (state) => state.session,
    getSystem: (state) => state.system,
    getCount: (state) => state.count,
    getMarqueeText: (state) => state.marquee_text,
    getSlideshows: (state) => state.slideshows,
    getVersion: (state) => {
      if (state.environment === 'release') return state.system_version;
      else return state.system_version + '/' + state.front_end_version;
    },
    getEnvironment: (state) => state.environment,
    getPermission: (state) => state.permission,
    getIsTestMode: (state) => state.isTestMode,
  },

  mutations: {
    SET_CONFIG(state, data) {
      state.config = data;
    },
    SET_VERSION(state, data) {
      state.system_version = data.ver;
      state.permission = data.permission;
    },
    SET_SYSTEM(state, data) {
      state.system = data;
    },
    SET_SESSION(state, data) {
      state.session = data;
    },
    SET_COUNT(state, data) {
      state.count = data;
    },
    SET_MARQUEE(state, data) {
      state.marquee_text = data;
    },
    SET_SLIDESHOWS(state, data) {
      state.slideshows = data;
    },
    SET_TEST_MODE(state, data) {
      state.isTestMode = data;
    },
  },

  actions: {
    //取得系統版號和來源類型支付等權限
    async getSystemInfo({ commit }) {
      const ver = await version();
      const permission = await applicationInfo();
      commit('SET_VERSION', { ver, permission });
      return Promise.resolve();
    },
    //取得建構POS系統的Web相關參數
    async getPosWebConfig({ commit }) {
      const config = await applicationConfig();
      commit('SET_CONFIG', config );
      return Promise.resolve();
    },
    //確認硬體狀態
    doCheckDeviceStatus() {
      return new Promise((resolve, reject) => {
        checkDeviceStatus().then((res) => {
          if (res.data.length > 0) {
            let text = '';
            res.data.forEach((e) => {
              text += `${e.device_type}：${e.reason}</br>`;
            });
            useConfirm({
              title: '週邊設備連線異常，請確認！',
              image: require('@/assets/images/icon-notice.png'),
              content: text,
              confirmText: '再次檢查',
              confirmColor: 'blue',
              confirm2Text: '略過',
              moreConfirm: true,
            })
              .then((val) => {
                if (val === '再次檢查') reject();
                else if (val === '略過') resolve();
              })
              .catch((e) => e);
          } else {
            resolve();
          }
        });
      });
    },
    //取得各式數量
    async getEcho({ commit, dispatch, rootGetters }) {
      try {
        const res = await echo();
        const filter = JSON.parse(JSON.stringify(res));
        delete filter.marquee_text;
        delete filter.slideshows;
        commit('SET_COUNT', filter);
        commit('SET_MARQUEE', res.marquee_text);
        commit('SET_SLIDESHOWS', res.slideshows);
        return Promise.resolve();
      } catch (error) {
        if (error.response?.status === 502) {
          await dispatch('upgrade/checkSoftwareStatus', '', { root: true });
          //確認軟體狀態，若正在安裝中則登出
          if (rootGetters['upgrade/getSoftwareStatus'] === 4) {
            //因更新中無法呼叫 logout api 因此僅清空資料
            commit('SET_SESSION', null);
            commit('handleOrder/RESET', '', { root: true });
            commit('manageOrder/RESET', '', { root: true });
            commit('accounting/RESET', '', { root: true });
            dispatch('order/doRestartOrder', '', { root: true });
            Router.push('/login');
            sessionStorage.clear();
            localStorage.clear();
          }
        }
      }
    },
    //取得班號
    async doGetDutySection({ commit }) {
      const res = await getDutySection();
      commit('SET_SYSTEM', res);
      return Promise.resolve();
    },
    //登入
    async doLogin({ commit }, data) {
      const res = await userLogin(data);
      sessionStorage.setItem('session', res.session);
      commit('SET_SESSION', res.session);
      return Promise.resolve(res);
    },
    //登出
    async doLogout({ commit, dispatch }) {
      await userLogout();
      //清空資料
      commit('SET_SESSION', null);
      commit('handleOrder/RESET', '', { root: true });
      commit('manageOrder/RESET', '', { root: true });
      commit('accounting/RESET', '', { root: true });
      dispatch('order/doRestartOrder', '', { root: true });
      Router.push('/login');
      sessionStorage.clear();
      localStorage.clear();
      return Promise.resolve();
    },
    //重開機
    async doReboot() {
      await reboot();
      return Promise.resolve();
    },
    //重開機
    async doShutdown() {
      await shutdown();
      return Promise.resolve();
    },
    //開錢櫃
    async doOpenCashBox() {
      await openCashBox();
      return Promise.resolve();
    },
    //取得訊息列表
    async doGetNotificationList(context, data) {
      const list = await notificationList(data);
      const total = await notificationSummary();
      return Promise.resolve({ list: list.data, total: total.total_count });
    },
    //讀取訊息
    async doReadNotification(context, id) {
      await notificationRead(id);
      return Promise.resolve();
    },
    //取得裝置列表
    async doGetDeviceList() {
      const list = await deviceList();
      return Promise.resolve(list.devices);
    },
    //儲存裝置設定
    async doDeviceSave(context, data) {
      const res = await deviceSave({ devices: data });
      return Promise.resolve(res);
    },
  },
};
